import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

const SRC = "/fondo_musical_home.mp3";
const VOLUME = 0.18;
const FADE_MS = 2500;

export const BackgroundMusic = () => {
  const audioRef = useRef(null);
  const startedRef = useRef(false);
  const fadeRef = useRef(null);
  const [muted, setMuted] = useState(() => localStorage.getItem("home_music_muted") === "1");

  const fadeIn = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (fadeRef.current) clearInterval(fadeRef.current);
    audio.volume = 0;
    const steps = 40;
    const stepMs = FADE_MS / steps;
    let i = 0;
    fadeRef.current = setInterval(() => {
      i += 1;
      const v = Math.min(VOLUME, (VOLUME * i) / steps);
      audio.volume = v;
      if (i >= steps) { clearInterval(fadeRef.current); fadeRef.current = null; }
    }, stepMs);
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.volume = 0;
    audio.muted = muted;

    const start = () => {
      if (startedRef.current || muted) return;
      startedRef.current = true;
      audio.play().then(fadeIn).catch(() => { startedRef.current = false; });
      cleanup();
    };
    const onInteract = () => start();
    const cleanup = () => {
      window.removeEventListener("pointerdown", onInteract);
      window.removeEventListener("keydown", onInteract);
      window.removeEventListener("scroll", onInteract);
      window.removeEventListener("touchstart", onInteract);
    };

    // Intento de reproducción automática al entrar (con fundido de entrada); si el
    // navegador lo bloquea, arranca en la primera interacción del usuario (una sola vez).
    if (!muted) {
      audio.play().then(() => { startedRef.current = true; fadeIn(); }).catch(() => {
        window.addEventListener("pointerdown", onInteract, { once: false });
        window.addEventListener("keydown", onInteract, { once: false });
        window.addEventListener("scroll", onInteract, { once: false });
        window.addEventListener("touchstart", onInteract, { once: false });
      });
    }
    return () => { cleanup(); if (fadeRef.current) clearInterval(fadeRef.current); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleMute = () => {
    const audio = audioRef.current;
    const next = !muted; // true = detenida
    setMuted(next);
    localStorage.setItem("home_music_muted", next ? "1" : "0");
    if (!audio) return;
    if (next) {
      if (fadeRef.current) clearInterval(fadeRef.current);
      audio.pause();
    } else {
      startedRef.current = true;
      audio.muted = false;
      audio.play().then(fadeIn).catch(() => {});
    }
  };

  return (
    <>
      <audio ref={audioRef} src={SRC} preload="auto" playsInline data-testid="home-bg-audio" />
      <button
        onClick={toggleMute}
        data-testid="home-music-toggle"
        aria-label={muted ? "Reproducir música" : "Parar música"}
        title={muted ? "Reproducir música de fondo" : "Parar música de fondo"}
        className="fixed bottom-24 right-5 z-[60] flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-[#0B1F44] text-white text-xs font-bold uppercase tracking-wide shadow-lg border border-white/15 hover:bg-[#13306b] transition-colors"
      >
        {muted ? <Volume2 className="h-4 w-4" /> : <VolumeX className="h-4 w-4" />}
        {muted ? "Reproducir música" : "Parar música"}
      </button>
    </>
  );
};

export default BackgroundMusic;
